export default "__VITE_ASSET__C$_B1hy7__"